import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { AccordionArrow } from '../../../../assets/svg';
import { COLORS, device } from '../../../../constants';
import { Title, Text } from '../../../../components';
import { FaqItem } from '../../../../types/globalTypes';
import { AccordionSubitem } from './AccordionSubitem';

interface AccordionItemProps {
  item: FaqItem;
}

export const AccordionItem: React.FC<AccordionItemProps> = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <AccordionWrapper>
      <AccordionItemWrapper onClick={toggleAccordion}>
        <AccordionHeader>
          <Title
            title={item.Title}
            minHeight={0}
            size={24}
            weight={600}
            lineHeight={32}
          />
          <Arrow $isOpen={isOpen}>
            <AccordionArrow color={COLORS.ACTIVE_ARROW} />
          </Arrow>
        </AccordionHeader>
        <AccordionContent $isOpen={isOpen}>
          <Text text={item.Description} size={18} />
        </AccordionContent>
      </AccordionItemWrapper>
      <SubitemList $isOpen={isOpen}>
        {item.Items.map(subitem => (
          <AccordionSubitem key={subitem.id} item={subitem} />
        ))}
      </SubitemList>
    </AccordionWrapper>
  );
};
const AccordionWrapper = styled.div``;
const AccordionItemWrapper = styled.div`
  background-color: ${COLORS.GRAY_BG_COLOR};
  padding: 40px;
  cursor: pointer;
  @media screen and ${device.md} {
    padding: 15px;
  }
`;

const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and ${device.md} {
    padding: 5px;
    > span {
      font-size: 18px;
      line-height: 24px;
    }
  }
  @media screen and ${device.sm} {
    padding: 0;
    > span {
      font-size: 15px;
      line-height: 18px;
    }
  }
`;

const Arrow = styled.span<{ $isOpen: boolean }>`
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.3s ease;
  svg {
    width: 18px;
    height: 36px;
  }
`;
const SubitemList = styled.div<{ $isOpen: boolean }>`
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  flex-direction: column;
`;
const AccordionContent = styled.div<{ $isOpen: boolean }>`
  max-height: ${({ $isOpen }) => ($isOpen ? '200px' : '0')};
  overflow: hidden;
  transition: all 0.2s ease;
  border-top: none;
  margin-top: ${({ $isOpen }) => ($isOpen ? '40px' : '0')};
  @media screen and ${device.md} {
    > h4 {
      font-size: 14px;
      line-height: 17px;
    }
    margin-top: ${({ $isOpen }) => ($isOpen ? '15px' : '0')};
  }
  @media screen and ${device.sm} {
    > h4 {
      font-size: 12px;
      line-height: 16px;
    }
  }
`;
